// Generate random amount between min and max
const randomAmount = (min, max) => 
  Number((Math.random() * (max - min) + min).toFixed(2));

// Generate random date within last 30 days
const randomDate = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

const mockTransactionTypes = [
  { type: 'debit', description: 'Amazon.com Purchase' },
  { type: 'debit', description: 'Walmart Store' },
  { type: 'debit', description: 'Target' },
  { type: 'debit', description: 'Costco Gas' },
  { type: 'debit', description: 'Netflix Subscription' },
  { type: 'debit', description: 'Uber Ride' },
  { type: 'debit', description: 'Starbucks Coffee' },
  { type: 'credit', description: 'Direct Deposit - Employer' },
  { type: 'credit', description: 'Bank Transfer Credit' },
  { type: 'credit', description: 'Refund - Amazon' },
  { type: 'debit', description: 'Phone Bill Payment' },
  { type: 'debit', description: 'Electric Bill Payment' },
  { type: 'debit', description: 'Internet Service' },
  { type: 'debit', description: 'Restaurant Payment' },
  { type: 'credit', description: 'PayPal Transfer' }
];

export const generateMockTransactions = (count = 20) => {
  return Array.from({ length: count }, () => {
    const transaction = mockTransactionTypes[Math.floor(Math.random() * mockTransactionTypes.length)];
    return {
      type: transaction.type,
      description: transaction.description,
      amount: transaction.type === 'credit' 
        ? randomAmount(100, 3000)
        : randomAmount(5, 200),
      date: randomDate(),
      status: 'completed',
      category: transaction.type === 'credit' ? 'income' : 'expense'
    };
  }).sort((a, b) => b.date - a.date);
};

export const initialAccounts = [
  {
    type: 'Checking',
    accountNumber: '12345678',
    balance: 2500.00,
    routingNumber: '021000021'
  },
  {
    type: 'Savings',
    accountNumber: '87654321',
    balance: 10000.00,
    routingNumber: '021000021'
  }
];

export const MOCK_TRANSACTIONS = [
  {
    id: 'mock-1',
    description: 'Direct Deposit - ACME Corp Payroll',
    amount: 2850.00,
    type: 'credit',
    date: new Date('2025-02-20T10:00:00'), // recent date in February 2025
    category: 'Income',
    status: 'Completed',
    isMock: true
  },
  {
    id: 'mock-2',
    description: 'Monthly Rent Payment',
    amount: 1500.00,
    type: 'debit',
    date: new Date('2025-02-01T09:30:00'), // start of February 2025
    category: 'Housing',
    status: 'Completed',
    isMock: true
  },
  {
    id: 'mock-3',
    description: 'Grocery Store Purchase - Whole Foods',
    amount: 156.78,
    type: 'debit',
    date: new Date('2025-02-20T15:45:00'), // end of February 2025
    category: 'Shopping',
    status: 'Completed',
    isMock: true
  },
  {
    id: 'mock-4',
    description: 'Car Insurance - Quarterly Payment',
    amount: 385.00,
    type: 'debit',
    date: new Date('2025-01-31T11:20:00'), // end of January 2025
    category: 'Insurance',
    status: 'Completed',
    isMock: true
  },
  {
    id: 'mock-5',
    description: 'ATM Withdrawal - Main Street',
    amount: 100.00,
    type: 'debit',
    date: new Date('2024-12-15T14:15:00'), // December 2024
    category: 'Withdrawal',
    status: 'Completed',
    isMock: true
  }
];

export const DEFAULT_ACCOUNTS = [
  {
    type: 'Checking',
    accountNumber: '12345678',
    balance: 2500.00,
    available: 2500.00,
    routingNumber: '021000021'
  },
  {
    type: 'Savings',
    accountNumber: '87654321',
    balance: 10000.00,
    available: 10000.00,
    routingNumber: '021000021'
  }
]; 